import { Navigate, useLocation } from "react-router-dom";

const LegacyReservationOutcomeRedirect = ({ to }) => {
	const location = useLocation();
	const params = new URLSearchParams(location.search || "");
	const hasReservationDiscriminator = ["flow", "durationMinutes", "sport"].some(
		(key) => params.has(key),
	);
	const search = hasReservationDiscriminator
		? location.search || ""
		: `${location.search || ""}${location.search ? "&" : "?"}flow=canchas`;

	return <Navigate to={{ pathname: to, search }} replace />;
};

export default LegacyReservationOutcomeRedirect;
